import Skycon from '@/components/Skycon/Skycon'
import { Chrome } from 'vue-color'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import DataModal from '../components/DataModal'
import axios from 'axios'
import config from '../../../config'

export default {
  name: 'profile',
  components: {
    Skycon,
    Chrome,
    vSelect,
    DataModal,
    DatePicker,
  },
  data() {
    return {
      data: [],
      dataSocial: [],
      tableOptions: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: { no: 'width-100', description: 'text-wrap' },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
      },
      endpoint: config.webprofileApiUrl,
      formData: {
        title_web: '',
        logo_1: {
          file: null,
          url: '',
        },
        logo_2: {
          file: null,
          url: '',
        },
        favicon: {
          file: null,
          url: '',
        },
      },
      columnsDatatable: ['label', 'url', 'contact_number', 'icon'],
      socialMedia: [],
      editData: null,
      imagesUrl: [],
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        this.isLoading = true

        const res = await axios.get(config.webprofileApiUrl + '/company-profile/profile/e-sea')

        if (res.data) {
          this.formData.title_web = res.data.title_web
          this.formData.logo_1.url = res.data.logo_1
          this.formData.logo_1.file = null
          this.formData.logo_2.url = res.data.logo_2
          this.formData.logo_2.file = null
          this.formData.favicon.url = res.data.favicon
          this.formData.favicon.file = null
        }

        const socialRes = await axios.get(config.webprofileApiUrl + '/company-profile/social-media')

        if (socialRes.data) {
          this.dataSocial = socialRes.data
          this.socialMedia = socialRes.data.map((item) => ({
            ...item,
            isEdit: false,
          }))
        }
      } catch (error) {
        this.$toasted.error('Gagal mendapatkan data')
      } finally {
        this.isLoading = false
      }
    },
    handleCancelSosmed(index) {
      this.socialMedia[index].label = this.dataSocial[index].label
      this.socialMedia[index].url = this.dataSocial[index].url
      this.socialMedia[index]['contact_number'] = this.dataSocial[index]['contact_number']
      this.socialMedia[index].icon = this.dataSocial[index].icon
      this.socialMedia[index].isEdit = false
    },
    handleEditSosmed(index) {
      this.socialMedia[index].isEdit = true
    },
    async handleDeleteSosmed(index) {
      if (confirm('Are you sure to delete?')) {
        try {
          this.isLoading = true

          await axios.delete(config.webprofileApiUrl + `/company-profile/social-media/${this.socialMedia[index].id}`)

          this.$toasted.success('Berhasil menghapus sosmed')
          this.socialMedia[index].isEdit = false
          this.getData()
        } catch (error) {
          this.$toasted.error('Gagal menghapus sosmed')
        } finally {
          this.isLoading = false
        }
      }
    },
    async handleSaveSosmed(index) {
      try {
        this.isLoading = true
        let bodyFormData = new FormData()

        bodyFormData.append('label', this.socialMedia[index].label)
        bodyFormData.append('url', this.socialMedia[index].url)
        bodyFormData.append('contact_number', this.socialMedia[index].contact_number)
        bodyFormData.append('icon', this.socialMedia[index].icon)

        await axios.patch(
          config.webprofileApiUrl + `/company-profile/social-media/${this.socialMedia[index].id}`,
          bodyFormData,
        )

        this.$toasted.success('Berhasil mengedit sosmed')
        this.socialMedia[index].isEdit = false
        this.getData()
      } catch (error) {
        this.$toasted.error('Gagal mengedit sosmed')
      } finally {
        this.isLoading = false
      }
    },
    async saveData() {
      try {
        this.isLoading = true
        let bodyFormData = {}

        bodyFormData['title_web'] = this.formData.title_web

        if (this.formData.logo_1.file) {
          const logo_1 = new FormData()
          logo_1.append('logo_1', this.formData.logo_1.file)
          await axios.patch(config.webprofileApiUrl + `/company-profile/profile/logo-1`, logo_1)
        }

        if (this.formData.logo_2.file) {
          const logo_2 = new FormData()
          logo_2.append('logo_2', this.formData.logo_2.file)
          await axios.patch(config.webprofileApiUrl + `/company-profile/profile/logo-2`, logo_2)
        }

        if (this.formData.favicon.file) {
          const favicon = new FormData()
          favicon.append('favicon', this.formData.favicon.file)
          await axios.patch(config.webprofileApiUrl + `/company-profile/profile/favicon`, favicon)
        }

        await axios.patch(config.webprofileApiUrl + `/company-profile/profile/e-sea`, bodyFormData)

        this.$toasted.success('Berhasil menyimpan profile')
        this.getData()
      } catch (error) {
        this.$toasted.error('Gagal menyimpan profile')
      } finally {
        this.isLoading = false
      }
    },
    async addSocialMedia(payload) {
      try {
        this.isLoading = true
        let bodyFormData = new FormData()

        bodyFormData.append('label', payload[0].value)
        bodyFormData.append('url', payload[1].value)
        bodyFormData.append('contact_number', payload[2].value)
        bodyFormData.append('icon', payload[3].value)

        await axios.post(config.webprofileApiUrl + `/company-profile/social-media/`, bodyFormData)

        this.$toasted.success('Berhasil menambahkan sosmed')
        this.getData()
      } catch (error) {
        this.$toasted.error('Gagal menambahkan sosmed')
      } finally {
        this.isLoading = false
      }
    },
    initModal() {
      this.fields = this.forms.reduce((acc, f, idx) => {
        if (f == 'no' || f == 'aksi' || f == 'created_at' || f == 'updated_at') return [...acc]

        if (f == 'image')
          return [
            ...acc,
            {
              id: `${f}-${idx}`,
              label: f,
              value: this.isEdit ? this.formsData[f] : [],
            },
          ]

        return [
          ...acc,
          {
            id: `${f}-${idx}`,
            label: f,
            value: this.isEdit ? this.formsData[f] : '',
          },
        ]
      }, [])
    },
    resetModal() {
      this.fields = null
      this.imagePath = null
    },
    handleClick() {
      this.$emit('click-ok', this.fields)
    },
    handleChangeFile(e, form) {
      const file = e.target.files[0]
      if (!file) return
      const newname = `${new Date().getTime()}${file.name}`
      const renamedFile = new File([file], newname, { type: file.type })
      const url = URL.createObjectURL(file)
      form.url = url
      form.file = renamedFile
      form.icon = renamedFile
    },
  },
}
